import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './SanKasthi.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';

import axios from 'axios';

import city from '../../../city.json'



function formatTime(rawTime, formatType = "24") {
  const [hoursStr, minutes] = rawTime.split(":");
  let hours = parseInt(hoursStr, 10);

  if (formatType === "12" || formatType === "12hr") {
    const period = hours >= 12 ? "PM" : "AM";
    const hour12 = hours % 12 || 12;
    return `${hour12}:${minutes} ${period}`;
  }

  if (formatType === "24+" || formatType === "24hr+") {
    return `${rawTime} hrs`;
  }

  return rawTime;
}



const sankashtiImages = {
  "Lambodara Sankashti": "https://static.toiimg.com/thumb/msid-117286849,imgsize-69224,width-400,resizemode-4/117286849.jpg",
  "Dwijapriya Sankashti": "https://images.moneycontrol.com/static-mcnews/2025/02/20250211051302_GANESH-JI.png?impolicy=website&width=770&height=431",
  "Bhalachandra Sankashti": "https://www.sanskritimagazine.com/wp-content/uploads/2022/02/ganeshji-1024x768.jpg",
  "Vikata Sankashti": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQanBBU68NThqohGM68QUffrk6s2liggin-ww&s",
  "Ekadanta Sankashti": "https://static.toiimg.com/thumb/msid-117286849,imgsize-69224,width-400,resizemode-4/117286849.jpg",
  "Krishnapingala Sankashti": "https://www.sanskritimagazine.com/wp-content/uploads/2022/02/ganeshji-1024x768.jpg",
  "Gajanana Sankashti": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQanBBU68NThqohGM68QUffrk6s2liggin-ww&s",
  "Heramba Sankashti": "https://images.moneycontrol.com/static-mcnews/2025/02/20250211051302_GANESH-JI.png?impolicy=website&width=770&height=431",
  "Vighnaraja Sankashti": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQanBBU68NThqohGM68QUffrk6s2liggin-ww&s",
  "Vakratunda Sankashti": "https://static.toiimg.com/thumb/msid-117286849,imgsize-69224,width-400,resizemode-4/117286849.jpg",
  "Ganadhipa Sankashti": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQanBBU68NThqohGM68QUffrk6s2liggin-ww&s",
  "Akhuratha Sankashti": "https://www.sanskritimagazine.com/wp-content/uploads/2022/02/ganeshji-1024x768.jpg",
};





const Sankasthi = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('Kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

      const [sankasthiList, setSankasthiList] = useState([]);
   // inside Sankasthi component state
const [popupFestival, setPopupFestival] = useState(null);

 const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);
const [selectedSankasthi, setSelectedSankasthi] = useState(null);




  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };


  const sankashtiTooltips = {
  "Lambodara Sankashti": "Lambodara Sankashti is dedicated to Lord Ganesha in his Lambodara form, symbolizing abundance and wisdom. Devotees observe fasts and seek his blessings to remove obstacles.",
  "Dwijapriya Sankashti": "Dwijapriya Sankashti is observed in honor of the form of Ganesha who is beloved by the twice-born (Brahmins). It's an auspicious day for spiritual learning and devotion.",
  "Bhalachandra Sankashti": "Bhalachandra Sankashti is dedicated to the moon-crested form of Ganesha. It symbolizes calmness and mental clarity. Devotees pray for peace and clear thinking.",
  "Vikata Sankashti": "Vikata Sankashti is associated with the fierce and challenging form of Ganesha who removes deep-rooted troubles and brings spiritual strength.",
  "Ekadanta Sankashti": "Ekadanta Sankashti is dedicated to the single-tusked form of Lord Ganesha, symbolizing sacrifice, focus, and resilience. It's an ideal day for self-discipline.",
  "Krishnapingala Sankashti": "Krishnapingala Sankashti worships the dark-hued form of Ganesha. It's believed to help destroy negative energies and past karmic burdens.",
  "Gajanana Sankashti": "Gajanana Sankashti honors the elephant-faced Ganesha. Devotees pray for wisdom, intellect, and removal of all impediments in life.",
  "Heramba Sankashti": "Heramba Sankashti is dedicated to the protective and warrior form of Ganesha who rides a lion. It's a day for invoking courage and divine shelter.",
  "Vighnaraja Sankashti": "Vighnaraja Sankashti is devoted to the king of obstacle removers—Ganesha. Devotees fast and pray for smooth undertakings in life and career.",
  "Vakratunda Sankashti": "Vakratunda Sankashti honors the curved-trunked form of Ganesha, representing adaptability and spiritual vision. It is ideal for initiating new ventures.",
  "Ganadhipa Sankashti": "Ganadhipa Sankashti celebrates Ganesha as the Lord of all Ganas (divine beings). It’s an auspicious day to seek leadership skills and divine favor.",
  "Akhuratha Sankashti": "Akhuratha Sankashti is dedicated to the mouse-riding form of Ganesha, symbolizing humility and wisdom. It’s a day to focus on devotion and service."
};

const festivals = {
  ganeshaChaturthi: {
    name: "Ganesha Chaturthi",
    significance: "Ganesha Chaturthi, also known as Vinayaka Chaturthi, celebrates the birth of Lord Ganesha, the remover of obstacles and the god of wisdom, prosperity, and good fortune. It is one of the most widely celebrated Hindu festivals, especially in Maharashtra, Karnataka, Andhra Pradesh, Telangana, and Goa.",
    mythology: "According to legend, Goddess Parvati created Ganesha from sandalwood paste to guard her while she bathed. When Lord Shiva tried to enter, Ganesha stopped him, leading to a conflict. In anger, Shiva severed Ganesha's head, but later restored him with the head of an elephant, granting him a boon that people would worship him before beginning any new venture.",
 
    specialPrasad: ["Modak", "Ladoo", "Puran Poli"],
    culturalAspect: "The festival also promotes social gatherings, community harmony, and cultural performances such as music, dance, and plays."
  },

  sakatChauth: {
    name: "Sakat Chauth",
    significance: "Sakat Chauth, also called Sankashti Chaturthi, is dedicated to Lord Ganesha and primarily observed by mothers for the well-being and long life of their children. It falls on the Chaturthi tithi of Krishna Paksha (waning phase of the moon) in the Hindu month of Magha.",
    mythology: "It is believed that on this day, worshiping Lord Ganesha removes hardships (Sankat) from life. A popular legend associates it with Goddess Sakat Mata, who blesses children with health and protection.",
    specialPrasad: ["Tilkut (sesame sweet)", "Rewari", "Groundnut ladoo"],
    culturalAspect: "In many regions, it is especially significant for mothers, as it is believed to safeguard children from illness and difficulties. Rural communities celebrate it with local traditions and group prayers."
  }
};


  useEffect(() => {
  const fetchSankasthiData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/sankashti?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.sankashtiDates) {
        setSankasthiList(response.data.sankashtiDates);
      } else {
        setSankasthiList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch sankasthi data:", error);
      setSankasthiList([]);
    }
  };

  fetchSankasthiData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };



  return (
    <div className="Sankasthi-container">
      <InnerNav />
      <div className="Sankasthi-content">
        <Zodiac />

        {/* Ekadashi Calendar JSX starts here */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Sankasthi Dates</h2>
              <div className="current-ekadashi">
                <img src="https://www.livehindustan.com/lh-img/smart/img/2024/10/12/1200x900/ekadashi_kab_hai_1728728958162_1728728958353.jpeg" alt="Moon" className="moon-preview" />
                <div>
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>


               <div className="ss-controls">
                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>
        {!selectedSankasthi ? (
         <div className="san-list">
              {sankasthiList.length === 0 && <p>No sankasthi puja data available for selected year/location.</p>}
              {sankasthiList.map((item, idx) => (
                <div
  className="san-item clickable-tile"
  key={idx}
  onClick={() => setSelectedSankasthi(item)}
>

                  <img
                    src={sankashtiImages[item.name] || "https://i.pinimg.com/736x/de/fe/da/defeda16bb6caa3d22589f3fe220c267.jpg"}
                    alt="sankasthi puja"
                  />
                  <div className="san-details">
                    <p className="san-date">{item.date}</p>
                    {/* <div className="tooltip-wrapper">
                      <div className="san-name">{item.name}</div>
                      <span className="tooltip-text">{sankashtiTooltips[item.name] || "No info available"}</span>
                    </div> */}

                    <div
                      className="san-name"
                      onClick={() => setSelectedSankasthi(item)}
                    >
                      {item.name}
                    </div>


                    <p className="san-phase">{item.day}</p>
                    <p className="san-tithi">{item.month}</p>
                    <p className="san-tithi">Chaturthi Time: {item.chaturthiTime}</p>
                  </div>
                  <div className="san-timings">
                    <p>{item.lunarDetail}</p>
                    <p>Begins: {formatTime(item.begins, timeFormat)}</p>
                    <p>Ends: {formatTime(item.ends, timeFormat)}</p>
                  </div>


                </div>
              ))}
            </div>
            ) : (
<div className="san-detail-view">
  <button
    className="back-btn"
    onClick={() => setSelectedSankasthi(null)}
  >
    ← Back
  </button>

  <h2>{selectedSankasthi.name}</h2>

  <img
    src={
      sankashtiImages[selectedSankasthi.name] ||
      "https://i.pinimg.com/736x/de/fe/da/defeda16bb6caa3d22589f3fe220c267.jpg"
    }
    alt={selectedSankasthi.name}
  />

  <p>
    {sankashtiTooltips[selectedSankasthi.name] ||
      "Detailed information will be available soon."}
  </p>

  <hr />

  <p><strong>Date:</strong> {selectedSankasthi.date}</p>
  <p><strong>Day:</strong> {selectedSankasthi.day}</p>
  <p><strong>Month:</strong> {selectedSankasthi.month}</p>
  <p><strong>Lunar Detail:</strong> {selectedSankasthi.lunarDetail}</p>
  <p><strong>Chaturthi Time:</strong> {selectedSankasthi.chaturthiTime}</p>
  <p><strong>Begins:</strong> {formatTime(selectedSankasthi.begins, timeFormat)}</p>
  <p><strong>Ends:</strong> {formatTime(selectedSankasthi.ends, timeFormat)}</p>
</div>

)}

        </div>

         <section className="sankasthi-wrapper">
      <h1 className="sankasthi-title">Sankashti Chaturthi</h1>
      <div className="sankasthi-texts">
        <p>
          Each lunar month in Hindu calendar has two Chaturthi Tithis. The one after Purnimasi or full moon during Krishna Paksha is known as Sankashti Chaturthi and the one after Amavasya or new moon during Shukla Paksha is known as Vinayaka Chaturthi.
          Although Sankashti Chaturthi fasting is done every month but the most significant Sankashti Chaturthi falls in month of Magha according to Purnimanta School and in month of Paush according to Amanta School.
        </p>

        <p>
          If Sankashti Chaturthi falls on Tuesday it is called Angarki Chaturthi and it is considered highly auspicious. Sankashti Chaturthi fast is mostly observed in Western and Southern India especially in Maharashtra and Tamil Nadu.
        </p>

        <h2>Sankashti Chaturthi Vrat</h2>
        <p>
          Devotees of Lord Ganesha keep fast from sunrise to moonrise on Sankashti Chaturthi. Sankashti means deliverance during troubled times. Lord Ganesha, the supreme lord of intelligence, symbolizes the remover of all obstacles. Hence it is believed that one can get rid of all obstacles by observing this fast.
        </p>

        <p>
          The fast is supposed to be strict and only fruit, roots (the part of a plant which is below ground) and vegetable products are supposed to be consumed. The staple Indian diet on Sankashti Chaturthi includes Sabudana Khichadi, potato and peanuts. Devotees break the fast at night after sighting of the moon.
        </p>

        <p>
          In North India Sankashti Chaturthi during Magha month is known as 
          <span className="popup-link" onClick={() => setPopupFestival('sakatChauth')}> Sakat Chauth</span>.  
          Also Vinayaka Chaturthi during Bhadrapada month is known as
           <span className="popup-link" onClick={() => setPopupFestival('ganeshaChaturthi')}> Ganesha Chaturthi</span>.
           Ganesha Chaturthi is celebrated by Hindus all over the world as the birthday of Lord Ganesha.
        </p>

        <p>
          Sankashti Chaturthi is also known as Ganesh Sankatahara or Sankatahara Chaturthi among Tamil Hindus.
        </p>

        <h2>Location based Sankashti Chaturthi Days</h2>
        <p>
          It is important to understand that fasting day for Sankashti Chaturthi might differ for two cities even if those cities are within same Indian state. Fasting for Sankashti Chaturthi depends on moonrise and it is observed on the day when there is moonrise while Chaturthi Tithi is prevailing. Hence Sankashti Chaturthi fasting might be observed on Tritiya Tithi i.e. one day before Chaturthi Tithi.
        </p>

        <p>
          As moonrise time is different for all cities it is important to refer Hindu calendar like this website which lists location based Sankashti Chaturthi days. As generating location based dates are time consuming most sources ignore this fact and publish single list for all Indian cities.
        </p>
      </div>
    </section>
        {/* Ekadashi Calendar JSX ends here */}
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
      {/* Popup Modal */}
      {popupFestival && (
        <div className="popup-overlay" onClick={() => setPopupFestival(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>{festivals[popupFestival].name}</h2>
            <p><strong>Significance:</strong> {festivals[popupFestival].significance}</p>
            <p><strong>Mythology:</strong> {festivals[popupFestival].mythology}</p>
            
            <p><strong>Special Prasad:</strong> {festivals[popupFestival].specialPrasad.join(", ")}</p>
            <p><strong>Cultural Aspect:</strong> {festivals[popupFestival].culturalAspect}</p>

            <button className="close-btn" onClick={() => setPopupFestival(null)}>Close</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Sankasthi;
